import VPageCardList from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageCardList', VPageCardList),
};
